export default __webpack_public_path__ + "static/media/small-batch-000000.d99b3f4f.png";